import { VariantProps } from 'tailwind-variants';
import { spinnerLoaderStyle } from './styles';

interface IComponentLoadingSpinnerProps
  extends VariantProps<typeof spinnerLoaderStyle.innerRing> {
  containerClassName?: string;
  innerRingClassName?: string;
  outerRingBoxClassName?: string;
  outerRingClassName?: string;
}

export function SpinnerLoader({
  borderStyle,
  color,
  containerClassName,
  innerRingClassName,
  outerRingBoxClassName,
  outerRingClassName,
}: IComponentLoadingSpinnerProps) {
  return (
    <div
      className={spinnerLoaderStyle.container({
        className: containerClassName,
      })}
    >
      <div
        className={spinnerLoaderStyle.outerRingBox({
          className: outerRingBoxClassName,
        })}
      >
        <div
          className={spinnerLoaderStyle.outerRing({
            borderStyle,
            className: outerRingClassName,
          })}
        />
      </div>
      <div
        className={spinnerLoaderStyle.innerRing({
          borderStyle,
          className: innerRingClassName,
          color,
        })}
      />
    </div>
  );
}
